import { AppRoutes, DashboardModules, KioskSubModules } from "./app.config";

export const Role = {
	Admin: "admin",
	Staff: "staff",
	Finance: "finance",
}

export const ALLOW_ALL = "*"

/**
 * Per-role access: `allowedModules` gates Kiosk vs Studio; `allowedPages` lists `matchPath` patterns per module
 * (same strings as each route def's `.match`), or `ALLOW_ALL` to allow every registered route in that module.
 * If a module is not in `allowedModules`, its pages are ignored (cannot access that module).
 */
export const ROLE_PERMISSIONS = {
	[Role.Admin]: {
		allowedModules: ALLOW_ALL,
		allowedPages: ALLOW_ALL,
	},
	[Role.Staff]: {
		allowedModules: [DashboardModules.HOME, DashboardModules.KIOSK],
		allowedPages: {
			[DashboardModules.KIOSK]: [
                AppRoutes[DashboardModules.HOME].INDEX.match,
                AppRoutes[DashboardModules.KIOSK][KioskSubModules.MACHINE].INDEX.match,
				AppRoutes[DashboardModules.KIOSK][KioskSubModules.MACHINE].KITCHEN_MODULES.match,
				AppRoutes[DashboardModules.KIOSK][KioskSubModules.MACHINE].GOD_MODE.match,
				AppRoutes[DashboardModules.KIOSK][KioskSubModules.MACHINE].FOODMAKING.match,
				AppRoutes[DashboardModules.KIOSK][KioskSubModules.TASKS].RECENT_TASKS.match,
				AppRoutes[DashboardModules.KIOSK][KioskSubModules.TASKS].TASK.match,
				AppRoutes[DashboardModules.KIOSK][KioskSubModules.TASKS].ACTIVE_TASKS.match,
				AppRoutes[DashboardModules.KIOSK][KioskSubModules.TASKS].SEARCH_TASKS.match,
				AppRoutes[DashboardModules.KIOSK][KioskSubModules.INVENTORY].INVENTORY_SNAPSHOT.match,
				AppRoutes[DashboardModules.KIOSK][KioskSubModules.INVENTORY].REPLENISH.match,
				AppRoutes[DashboardModules.KIOSK][KioskSubModules.ORDERS].RECENT_ORDERS.match,
				AppRoutes[DashboardModules.KIOSK][KioskSubModules.ORDERS].ORDER_DETAILS.match,
				AppRoutes[DashboardModules.KIOSK][KioskSubModules.OPERATIONS].XOOKEEPER_PLANNED_TASKS.match,
				AppRoutes[DashboardModules.KIOSK][KioskSubModules.OPERATIONS].XOOKEEPER_PAST_TASKS.match,
			],
		},
	},
	[Role.Finance]: {
		allowedModules: [DashboardModules.HOME, DashboardModules.KIOSK],
		allowedPages: {
			[DashboardModules.KIOSK]: [
                AppRoutes[DashboardModules.HOME].INDEX.match,
                AppRoutes[DashboardModules.KIOSK][KioskSubModules.MACHINE].INDEX.match,
				AppRoutes[DashboardModules.KIOSK][KioskSubModules.ORDERS].ORDER_DETAILS.match,
				AppRoutes[DashboardModules.KIOSK][KioskSubModules.ORDERS].RECENT_ORDERS.match,
				AppRoutes[DashboardModules.KIOSK][KioskSubModules.OFFERS].APPLY.match,
				AppRoutes[DashboardModules.KIOSK][KioskSubModules.BUSINESS].BALANCE_SHEET.match,
			],
		},
	},
}

/**
 * Preferred landing route when user opens `/:machineId` — uses `.getPath(machineId)` for redirects.
 */
export const ROLE_MACHINE_HOME_ROUTE = {
	[Role.Admin]: AppRoutes[DashboardModules.KIOSK][KioskSubModules.MACHINE].KITCHEN_MODULES,
	[Role.Staff]: AppRoutes[DashboardModules.KIOSK][KioskSubModules.MACHINE].KITCHEN_MODULES,
	[Role.Finance]: AppRoutes[DashboardModules.KIOSK][KioskSubModules.ORDERS].RECENT_ORDERS,
}
